<template>
    <div class="header">
        <div class="header-content" @click="isDropDownMenu = !isDropDownMenu">
            <div class="header-content-button">...</div>
            Пользователь
            <div class="header-dropdown-menu" v-show="isDropDownMenu">
                <div class="header-dropdown-menu-item" @click="$router.push('/account')">Личный кабинет</div>
                <div class="header-dropdown-menu-item" @click="$router.push('/logout')">Выход</div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .header-dropdown-menu {
        display: block;
        position: absolute;
        width: 190px;
        height: auto;
        background: #ffffff;
        margin-top: 10px;
        -webkit-box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
        -moz-box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
        box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
        padding-bottom: 20px;
        padding-top: 10px;
    }
    .header-dropdown-menu-item {
        display: block;
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 10px;
        font-size: 14px;
        cursor: pointer;
    }
    .header-dropdown-menu-item:hover {
        text-decoration: underline;
        color: blue;
    }
    .header {
        display: block;
        width: 100% !important;
        height: 50px !important;
        border-bottom: 3px solid #E7F0FF;
    }
    .header-content {
        display: block;
        float: right;
        min-width: 200px;
        border: 0px solid;
        margin-top: 10px;
        padding-top: 5px;
        cursor: pointer;
    }
    .header-content-button {
        display: inline-block;
        width: 31px;
        height: 31px;
        background: #6D9AE8;
        border-radius: 31px;
        color: #ffffff;
        font-size: 30px;
        box-sizing: border-box;
        line-height: 15px !important;
        padding-top: -35px;
        vertical-align: top;
        text-align: center;
        margin-right: 15px;
        margin-top: -5px;
        cursor: pointer;
    }
    .header-content-button:hover {
        -webkit-box-shadow: 0px 2px 8px 0px rgba(34, 60, 80, 0.2);
        -moz-box-shadow: 0px 2px 8px 0px rgba(34, 60, 80, 0.2);
        box-shadow: 0px 2px 8px 0px rgba(34, 60, 80, 0.2);
    }
</style>

<script>
export default {
    name: 'Header',
    data() {
        return {
            isDropDownMenu: false
        }
    },
    methods: {
        mouseOver() {
            this.isDropDownMenu = !this.isDropDownMenu
        }
    }
}
</script>